import { httpClient } from "./httpClient";

const base = "/api/calendario-no-laborable";

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.append(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : "";
};

export const listarCalendarioNoLaborable = (params) =>
  httpClient.get(`${base}${buildQuery(params)}`);
export const sugerirFeriados = (anio) =>
  httpClient.get(`${base}/sugeridos${buildQuery({ anio })}`);
export const obtenerCalendarioNoLaborable = (id) => httpClient.get(`${base}/${id}`);
export const crearCalendarioNoLaborable = (payload) => httpClient.post(base, payload);
export const actualizarCalendarioNoLaborable = (id, payload) =>
  httpClient.put(`${base}/${id}`, payload);
export const eliminarCalendarioNoLaborable = (id) => httpClient.del(`${base}/${id}`);

const calendarioNoLaborableService = {
  listar: listarCalendarioNoLaborable,
  sugerir: sugerirFeriados,
  obtener: obtenerCalendarioNoLaborable,
  crear: crearCalendarioNoLaborable,
  actualizar: actualizarCalendarioNoLaborable,
  eliminar: eliminarCalendarioNoLaborable,
};

export default calendarioNoLaborableService;
